import { ArticleMeta } from 'types/blog';

// ==============================|| 記事のメタ ||============================== //
//
// 一覧・カテゴリ一覧・関連記事のカードは、このファイルだけを読む。
// 本文(同名の .ts)と分けているのは、一覧を描くのに全記事の本文まで
// JSバンドルへ入れないため(詳しくは src/const/blog/registry.ts)。
//
// ★ ここに本文を書かないこと。書いた瞬間、一覧がそれを読み込むようになる。

export const meta: ArticleMeta = {
    slug: 'jihatsukan-ketsujo-gensan',
    title: '児発管欠如減算｜起算は翌々月、翌月末までの補充で回避できる',
    description:
        '児童発達支援管理責任者が退職して欠員になったとき、減算はいつから始まるのか。起算は欠如が生じた月の翌々月で、翌月の末日までに人員基準を満たせば減算は生じません。児発管欠如減算の減算率70/100・50/100の数え方、未配置の間の基本報酬の算定、個別支援計画未作成減算との二重適用を条文の原文つきで整理しました。',
    excerpt:
        '児発管が辞めた。次の人はまだ決まっていない。残されている時間は、思っているより長めです。まず起算日と補充の期限から確認してください。',
    category: '運営指導',
    keywords: [
        '児発管欠如減算',
        '児童発達支援管理責任者 欠如',
        '児発管 退職 減算',
        '人員欠如減算 児発管',
        '児発管 不在 報酬'
    ],
    publishedAt: '2026-07-02',
    updatedAt: '2026-09-15',
};
